import React, { useState, useRef } from "react";

import Template from "./CartItem.jsx";
import useEnsureVisible from "../../hooks/useEnsureVisible.js";
import "./styles.styl";

export default function CartItem(props) {
  const {
    item,
    isItemOpen,
    openedId,
    setEditVisible,
    cartItemListRef,
    is_favourite,
  } = props;
  const [changeId, setChangeId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const cardWrapperRef = useRef(null);
  // custom hooks that ensures the card is visible on screen when opened
  useEnsureVisible(isItemOpen, openedId, cardWrapperRef, cartItemListRef);

  function handleIncrementClick(e, syncWithRule) {
    const action = 1;
    const patch = { ...item, action };
    props.onChange(patch, syncWithRule);
  }

  function handleDecrementClick(e, syncWithRule) {
    const action = -1;
    const patch = { ...item, action };
    props.onChange(patch, syncWithRule);
  }

  function handleDropdownQuantityChange(e, amount, syncWithRule) {
    const action = amount;
    const patch = { ...item, action };
    props.onChange(patch, syncWithRule);
  }

  async function handleRemoveClick() {
    setIsLoading(true);
    const patch = { ...item };
    await props.onRemove(patch, () => setIsLoading(false));
  }

  function toggleEditVisible(id) {
    if (props.sold) return;
    setEditVisible(id);
  }

  return (
    <div>
      <Template
        {...props}
        isItemOpen={isItemOpen}
        handleIncrementClick={handleIncrementClick}
        handleDecrementClick={handleDecrementClick}
        handleDropdownQuantityChange={handleDropdownQuantityChange}
        handleRemoveClick={handleRemoveClick}
        toggleEditVisible={toggleEditVisible}
        changeId={changeId}
        setChangeId={setChangeId}
        is_favourite={is_favourite}
        isLoading={isLoading}
      />
    </div>
  );
}
